var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.basketIs.initial)?_c('div',[_c('strong',[_vm._v(_vm._s(_vm.location.name))]),_vm._v(", "+_vm._s(_vm.locationAddress.street)+", "+_vm._s(_vm.locationAddress.zip)+" "+_vm._s(_vm.locationAddress.city)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }